import { useRef, useEffect } from "react";

interface Options {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  /** how far from the bottom of the viewport to trigger; default is bottom 25% */
  rootMargin?: string;
}

export function useInfiniteScroll({ hasMore, isLoading, onLoadMore, rootMargin = "0px 0px -25% 0px" }: Options) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          onLoadMore();
        }
      },
      { root: null, rootMargin }
    );

    const el = sentinelRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
      observer.disconnect();
    };
  }, [hasMore, isLoading, onLoadMore, rootMargin]);

  return sentinelRef;
}
